<div *ngIf="!displayMobileView" class="content-table-pointer">
  <!-- [disableLink]="styleClass == 'gray-md-rows'" -->
  <ion-row
    [class]="'overflow-hidden content' + (styleClass ? ' ' + styleClass : '')"
    [routerLink]="styleClass == 'gray-md-rows' ? [] : [routerLink]"
    (click)="styleClass == 'gray-md-rows' ? onEmitEvent() : ''"
  >
    <ion-col
      [size]="styleClass == 'gray-md-rows' ? 3 : 2"
      class="report-task-view__column"
      >{{ row.createdAt | dateSti }}</ion-col
    >
    <ion-col
      size="3"
      class="report-task-view__column"
      *ngIf="styleClass != 'gray-md-rows'"
      >{{ row.report.title }}</ion-col
    >
    <ion-col
      [size]="styleClass == 'gray-md-rows' ? 3 : 2"
      class="report-task-view__column"
      >{{ row.assignmentBy.firstName }} {{ row.assignmentBy.lastName }}</ion-col
    >
    <ion-col
      [size]="styleClass == 'gray-md-rows' ? 3 : 2"
      class="report-task-view__column"
      >{{ row.performedBy.firstName }} {{ row.performedBy.lastName }}</ion-col
    >
    <ion-col
      [size]="styleClass == 'gray-md-rows' ? 3 : 2"
      class="report-task-view__column"
    >
      <app-status
        [directionColumn]="customData"
        [color]="
          dictionaryService.getDictionaryValueColor(
            dictionaryService.reportTaskStatusValues,
            row.status
          )
        "
        [name]="
          dictionaryService.valueName(
            dictionaryService.reportTaskStatusValues,
            row.status
          )
        "
      ></app-status>
    </ion-col>
    <ion-col
      size="3"
      *ngIf="styleClass !== 'gray-md-rows'"
      class="report-task-view__column"
    >
      <app-status
        [directionColumn]="customData"
        [color]="
          dictionaryService.getDictionaryValueColor(
            dictionaryService.reportPriorityValues,
            row.report.priority
          )
        "
        [name]="
          dictionaryService.valueName(
            dictionaryService.reportPriorityValues,
            row.report.priority
          )
        "
      ></app-status>
    </ion-col>
  </ion-row>
</div>

<ion-card
  [ngClass]="
    styleClass == 'gray-md-rows' ? 'content-card' : 'content-card-noborder'
  "
  (click)="styleClass == 'gray-md-rows' ? onEmitEvent() : ''"
  *ngIf="displayMobileView && row"
  [routerLink]="styleClass == 'gray-md-rows' ? [] : [routerLink]"
>
  <ion-card-content class="invitation-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col class="space-between">
          <app-status
            [color]="
              dictionaryService.getDictionaryValueColor(
                dictionaryService.reportTaskStatusValues,
                row.status
              )
            "
            [name]="
              dictionaryService.valueName(
                dictionaryService.reportTaskStatusValues,
                row.status
              )
            "
          ></app-status>
          <ion-text class="report-task-number">ZAD/{{ row.id }}</ion-text>
          <span>
            <span class="priority-flag">
              <ion-icon class="icon-and-text-in-same-line" src="../../../../assets/icons/flag.svg"> </ion-icon>
            </span>
            <span class="icon-and-text-in-same-line priority-name">
              {{
                dictionaryService.valueName(
                  dictionaryService.reportPriorityValues,
                  row.report.priority
                )
              }}
            </span>
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-content>
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col>
          <ion-icon mobile src="assets/icons/calendar-gray.svg"></ion-icon>
          <ion-text class="icon-label-text">
            {{ row.createdAt | dateSti }}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="margin-description">
          <ion-icon mobile src="assets/icons/reader.svg"></ion-icon>
          <ion-text class="icon-label-text report-task-view__description">
            {{ row.description ? row.description : '-'  }}</ion-text>

        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="7" size-md="7" size-xs="14">
          <div class="block user-box">
            <ion-text class="inv-info">{{
              "REPORT_TASK.TASK_FROM" | translate
            }}</ion-text>
            <app-user-with-avatar
              *ngIf="showUsers"
              [user]="row.assignmentBy"
            ></app-user-with-avatar>
          </div>
        </ion-col>
        <ion-col size-md="7" size-xs="14" *ngIf="row.idUserPerformedBy">
          <div class="block user-box">
            <ion-text class="inv-info">{{
              "REPORT_TASK.TASK_TO" | translate
            }}</ion-text
            ><br />
            <app-user-with-avatar
              *ngIf="showUsers"
              [user]="row.performedBy"
            ></app-user-with-avatar>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
